import { updateApplet } from "shared/components/connection_card/api.js"

const PushNotification = (appletId: string, attribute: string) => {
  const toggle = document.querySelector<HTMLButtonElement>(`button[data-switch-target=${attribute}]`)

  toggle?.addEventListener("click", () => {
    const newValue = toggle.getAttribute("aria-checked") !== "true"

    updateApplet({ appletId: `${appletId}`, [attribute]: newValue }).then(response => {
      if (response?.errors.length == 0) {
        toggle.setAttribute("aria-checked", String(newValue))
        toggle.classList.toggle("switch-field-on", newValue)
      } else {
        window.appendFlash("Error updating your Applet's notification. Try again soon.", "danger")
      }
    })
  })
}

export default PushNotification
